
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningAcknowledgedIec as ObiWarningAcknowledgedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-acknowledged-iec.js';
 
 
 

 
 export const ObiWarningAcknowledgedIec = createComponent({
   react: React,
   tagName: 'obi-warning-acknowledged-iec',
   elementClass: ObiWarningAcknowledgedIecElement,
   events: {
     
   }
  });
 
 